import BaseTopBar from "@ls/react-top-bar";
import React from "react";
import InfoSection from "components/InfoSection";
import KebabMenu from "components/KebabMenu";
import MainTitle from "components/MainTitle";
import { useDispatch, useSelector } from "react-redux";
import { toggleSelectionDrawer } from "state/app/actions";
import { selectSelectionDrawerOpen } from "state/app/selector";

const TopBar = (props) => {
  const dispatch = useDispatch();
  const menuButtonActive = useSelector(selectSelectionDrawerOpen);
  const onMenuButtonClick = React.useCallback(() => {
    dispatch(toggleSelectionDrawer(true));
  }, [dispatch]);
  return (
    <BaseTopBar
      onMenuButtonClick={onMenuButtonClick}
      menuButtonActive={menuButtonActive}
      mainTitleComponent={<MainTitle />}
      infoSection={<InfoSection />}
      rightSideComponent={<KebabMenu />}
      appName="Account Summary"
    />
  );
};

export default TopBar;
